import { render } from "./RemoveTrustedDevice.vue?vue&type=template&id=39b4e584&scoped=true"
import script from "./RemoveTrustedDevice.vue?vue&type=script&lang=js"
export * from "./RemoveTrustedDevice.vue?vue&type=script&lang=js"

import "./RemoveTrustedDevice.vue?vue&type=style&index=0&id=39b4e584&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b4e584"]])

export default __exports__